var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FlagsApiStrategy } from './flagsApiStrategy';
import { FlagsLocalStrategy } from './flagsLocalStrategy';
import { FlagsUnleashStrategy } from './flagsUnleashProxyStrategy';
export class FlagsModule {
    /**
     * Initialize flags.
     * @param userId User ID.
     */
    static init(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.type = config.type;
            switch (config.type) {
                case 'UNLEASH': {
                    const strategy = new FlagsUnleashStrategy(config.config);
                    yield strategy.init();
                    this.strategy = strategy;
                    break;
                }
                case 'LOCAL': {
                    const strategy = new FlagsLocalStrategy(config.config);
                    this.strategy = strategy;
                    break;
                }
                case 'API': {
                    const strategy = new FlagsApiStrategy(config.config);
                    yield strategy.init();
                    this.strategy = strategy;
                    break;
                }
            }
        });
    }
    /**
     * Update dynamic context.
     * @param config
     */
    static update(config) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (this.type) {
                case 'UNLEASH': {
                    const strategy = this.strategy;
                    yield strategy.update(config);
                    break;
                }
            }
        });
    }
    /**
     * Feature is enabled.
     * @param name Feature name.
     */
    static isEnabled(name) {
        var _a, _b;
        return (_b = (_a = this.strategy) === null || _a === void 0 ? void 0 : _a.isEnabled(name)) !== null && _b !== void 0 ? _b : false;
    }
}
